import { render, staticRenderFns } from "./serversList.vue?vue&type=template&id=65fb231b&"
import script from "./serversList.vue?vue&type=script&lang=js&"
export * from "./serversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fb231b')) {
      api.createRecord('65fb231b', component.options)
    } else {
      api.reload('65fb231b', component.options)
    }
    module.hot.accept("./serversList.vue?vue&type=template&id=65fb231b&", function () {
      api.rerender('65fb231b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/serversList.vue"
export default component.exports